import { Order } from '../../../requests/caipirinha-api/interfaces/order.interface';
import { useGtm } from '../useGtm';
import { ReviewPaymentDataLayer } from '../../../requests/caipirinha-api/interfaces/gtm.interface';

export const useReviewPaymentGtm = () => {
  const {
    setDataLayer,
    getPaymentTypes,
    getProducts,
    getServices,
    getRevenue,
  } = useGtm();

  const sendDataToGtm = (order: Order) => {
    const { id, details } = order;
    const shippingValue = details.shipping?.value;
    const products = [
      ...getProducts(details.products),
      ...getServices(details.services),
    ];

    const data: ReviewPaymentDataLayer[] = [
      {
        event: 'track.purchase',
        transaction_id: id,
        payment_type: getPaymentTypes(details.payments),
      },
      {
        ecommerce: null,
      },
      {
        event: 'purchase.ga4',
        ecommerce: {
          transaction_id: id,
          value: details.amount,
          shipping: shippingValue ?? 0,
          currency: 'BRL',
          payment_type: getPaymentTypes(details.payments),
          items: products.map(product => ({
            item_id: product.id,
            item_name: product.name,
            price: Number(product.price),
            quantity: Number(product.quantity),
          })),
        },
      },
      {
        ecommerce: null,
      },
      {
        event: 'purchase.ga3',
        payment_type: getPaymentTypes(details.payments),
        ecommerce: {
          purchase: {
            actionField: {
              id,
              revenue: Number(getRevenue(details.amount, shippingValue)),
              shipping: shippingValue ?? 0,
            },
            products: products.map(product => ({
              id: product.id,
              name: product.name,
              price: Number(product.price),
              quantity: Number(product.quantity),
            })),
          },
        },
      },
    ];

    for (const item of data) {
      setDataLayer(item);
    }
  };

  return { sendDataToGtm };
};
